import { jewlr_t } from "helpers/application"

export const gemstones = [
  {
    birthmonth: "January",
    code: ["01GARN", "S01GARN"],
    description:
      "Garnet is January’s deep red birthstone that was worn by the pharaohs of Ancient Egypt. It is thought to bring passion, vitality, and good luck, leadership to its wearer. Red garnet is the most popular variety of the garnet gemstone group and is durable enough to wear every day.",
    info: "Garnet",
    traits: ["Passion", "Vitality", "Good Luck"],
  },
  {
    birthmonth: "February",
    code: ["02AMTH", "S02AMTH"],
    description: `February’s regal birthstone with purple hues is perfect for the season of love! St. Valentine was ${jewlr_t(
      "terms.recognized"
    )} for wearing an amethyst ring with the image of Cupid carved into it. Part of the quartz gem group, amethyst is thought to bring clarity, wisdom, and intuition to its wearer.`,
    info: "Amethyst",
    traits: ["Clarity", "Wisdom", "Intuition"],
  },
  {
    birthmonth: "March",
    code: ["03AQUA", "S03AQUA"],
    description:
      "March’s serene and tranquil birthstone features a calming shade of blue that is reminiscent of the sea. The perfect nod to spring, this healing stone is associated with courage, protection, and insight. As part of the beryl mineral group, aquamarine is durable enough to wear every day.",
    info: "Aquamarine",
    traits: ["Courage", "Protection", "Insight"],
  },
  {
    birthmonth: "April",
    code: ["04DIAM"],
    description:
      "Diamond is April’s sparkling birthstone and stands for eternity, strength, and protection. Natural diamonds are formed within the earth under extreme circumstances. They are considered to be the hardest material on earth and one of nature’s most precious creations.",
    info: "Genuine Diamond",
    traits: ["Eternity", "Strength", "Protection"],
  },
  {
    birthmonth: "April",
    code: ["MOISS"],
    description: `An affordable alternative for April’s birthstone, moissanite helps aid wisdom, clarity, and wholeness. It is similar in durability, ${jewlr_t(
      "terms.color"
    )}, and brilliance to diamonds. Extremely rare in its natural state, we carry lab-created moissanite with exceptional quality and value.`,
    info: "Moissanite",
    traits: ["Wisdom", "Clarity", "Wholeness"],
  },
  {
    birthmonth: "April",
    code: ["04WTPZ"],
    description: `April’s alternative birthstone is the White Topaz. White topaz is a clear and ${jewlr_t(
      "terms.color"
    )}less variety of the silicate mineral family and represents strength, clarity, and confidence. With its natural sparkle and scintillating appearance, white topaz is an affordable option to diamond.`,
    info: "White Topaz",
    traits: ["Strength", "Clarity", "Confidence"],
  },
  {
    birthmonth: "May",
    code: ["05EMER", "S05EMER"],
    description: `Emerald is May’s enchanting birthstone with rich green ${jewlr_t(
      "terms.color"
    )}. Prized for their unique beauty, emeralds help the wearer with peace, balance, and reason. As part of the beryl mineral group, emerald is durable enough to wear every day.`,
    info: "Emerald",
    traits: ["Peace", "Balance", "Reason"],
  },
  {
    birthmonth: "June",
    code: ["06PEARL"],
    description: `Pearl is June’s lustrous birthstone with a calming effect. Symbolic of hope, positivity, and purity, pearls are classic, timeless and organic in nature. Our collection of modern pearl ${jewlr_t(
      "terms.jewelry"
    )} pieces are designed to showcase this shimmering birthstone.`,
    info: "Pearl",
    traits: ["Hope", "Positivity", "Purity"],
  },
  {
    birthmonth: "June",
    code: ["S06ALEX"],
    description: `Alexandrite is June’s dynamic, ${jewlr_t(
      "terms.color"
    )}-changing birthstone known for bringing awareness, enlightenment, and good fortune. Discovered in Russia and named after Emperor Alexander II, alexandrite is part of the chrysoberyl mineral group. Due to its extreme rarity, we only offer simulated alexandrite which emulates the same beautiful characteristics of genuine alexandrite.`,
    info: "Alexandrite",
    traits: ["Awareness", "Enlightenment", "Good Fortune"],
  },
  {
    birthmonth: "June",
    code: ["06SQTZ", "S06SQTZ"],
    description: `Smokey Quartz is June's alternative birthstone with a warm earthy-brown ${jewlr_t(
      "terms.color"
    )}. Said to provide endurance, serenity, and enlightenment, this modern gemstone is the national stone of Scotland. Smokey quartz is a silicon dioxide crystal that is found across the globe.`,
    info: "Smokey Quartz",
    traits: ["Endurance", "Serenity", "Enlightenment"],
  },
  {
    birthmonth: "July",
    code: ["07RUBY", "S07RUBY"],
    description: `Ruby is July's regal birthstone with a lush red ${jewlr_t(
      "terms.color"
    )}. A beautiful and popular ${jewlr_t(
      "terms.color"
    )}ed gemstone, the ruby ${jewlr_t(
      "terms.symbolize"
    )}s friendship, love, and passion. Rubies are from the corundum mineral group, are extremely tough, and are perfect for everyday wear.`,
    info: "Ruby",
    traits: ["Friendship", "Love", "Passion"],
  },
  {
    birthmonth: "August",
    code: ["08PERI", "S08PERI"],
    description:
      "August's birthstone is Peridot – a unique gemstone with a vibrant green hue. Named the 'Gem of the Sun' by the Egyptians, it represents strength, prosperity, and growth through understanding and awareness. Peridot is durable enough to wear every day.",
    info: "Peridot",
    traits: ["Strength", "Prosperity", "Growth"],
  },
  {
    birthmonth: "September",
    code: ["09BSAP", "S09BSAP"],
    description: `September's noble birthstone is the blue sapphire with a rich deep ${jewlr_t(
      "terms.color"
    )}. Blue sapphires offer protection from harm and ${jewlr_t(
      "terms.symbolize"
    )} peace, happiness, and insight. As a popular ${jewlr_t(
      "terms.color"
    )}ed gemstone from the corundum mineral group, sapphires are perfect for ${jewlr_t(
      "terms.jewelry"
    )}.`,
    info: "Blue Sapphire",
    traits: ["Peace", "Happiness", "Insight"],
  },
  {
    birthmonth: "October",
    code: ["10OPAL", "S10OPAL"],
    description: `Opal is October’s bewitching play-of-${jewlr_t(
      "terms.color"
    )} birthstone. These unique gemstones are associated with imagination, love and spontaneity. The opal is classified as a hydrated silica mineraloid and is unlike any other birthstone due to its composition and kaleidoscope of ${jewlr_t(
      "terms.color"
    )}s.`,
    info: "Opal",
    traits: ["Imagination", "Love", "Spontaneity"],
  },
  {
    birthmonth: "October",
    code: ["10PTOU", "S10PTOU"],
    description:
      "Pink tourmaline is October’s alternative birthstone with a range of hues from pale and light to vivid and hot. It is beautiful, durable, and perfect for everyday wear. Pink tourmaline is a natural amplifier and helps promote inspiration, balance, and confidence.",
    info: "Pink Tourmaline",
    traits: ["Inspiration", "Balance", "Confidence"],
  },
  {
    birthmonth: "November",
    code: ["11CITR", "S11CITR"],
    description:
      "Citrine is November’s exquisite birthstone with a warm, golden hue. This stone is associated with qualities of optimism, endurance, and generosity. As part of the quartz mineral group, citrine is considered the top-selling yellow-to-orange gem due to its durability and affordability.",
    info: "Citrine",
    traits: ["Optimism", "Endurance", "Generosity"],
  },
  {
    birthmonth: "December",
    code: ["12BTPZ", "S12BTPZ"],
    description: `Blue topaz is December’s birthstone with icy blue hues. This beautiful calming stone helps provide strength, confidence, and clarity to its wearer. Perfect for ${jewlr_t(
      "terms.jewelry"
    )}, blue topaz is part of the topaz gem group and is durable enough for everyday wear.`,
    info: "Blue Topaz",
    traits: ["Strength", "Confidence", "Clarity"],
  },
  {
    code: ["04BDIA", "F04BDIA"],
    description: `Dramatic and bold, black diamonds are naturally black or near black in ${jewlr_t(
      "terms.color"
    )}. These fancy diamonds have the same qualities as ${jewlr_t(
      "terms.color"
    )}less diamonds and are thought to provide the wearer protection, clarity, and wisdom.`,
    info: "Black Diamond",
    traits: ["Protection", "Clarity", "Wisdom"],
  },
  {
    code: ["PSAP"],
    description:
      "Pink sapphire is a stone of protection that comes in many shades, varying from pale pink to bold magenta. Worn throughout the ages for protection and good fortune, pink sapphires promote love, compassion, and courage.",
    info: "Pink Sapphire",
    traits: ["Love", "Compassion", "Courage"],
  },
  {
    code: ["GSAP"],
    description: `Green sapphire is a stone of tranquility with a natural and soothing green ${jewlr_t(
      "terms.color"
    )}. Worn throughout the ages for protection and good fortune, the Green Sapphire helps bring wisdom, integrity, and tolerance to the wearer.`,
    info: "Green Sapphire",
    traits: ["Wisdom", "Integrity", "Tolerance"],
  },
  {
    code: ["OSAP"],
    description: `Orange sapphire is a stone of wisdom with ${jewlr_t(
      "terms.color"
    )}ing that ranges from pale orange to a vivid reddish-orange. Worn throughout the ages for protection and good fortune, the orange sapphire imparts vitality, strength, and creativity to the wearer.`,
    info: "Orange Sapphire",
    traits: ["Wisdom", "Integrity", "Tolerance"],
  },
  {
    code: ["YSAP"],
    description:
      "Yellow sapphire is a stone of wealth and attraction with an intense golden hue. Worn throughout the ages for protection and good fortune, the yellow sapphire stimulates intellect and encourages adventure and invention.",
    info: "Yellow Sapphire",
    traits: ["Intellect", "Adventure", "Invention"],
  },
  {
    code: ["04CZIR"],
    description: `The sparkling cubic zirconia is a lab-created, conflict-free alternative to natural diamonds. Affordable and practical, cubic zirconia is said to help with positivity, calmness, and focus and is the perfect stone for travel ${jewlr_t(
      "terms.jewelry"
    )}.`,
    info: "Cubic Zirconia",
    traits: ["Positivity", "Calmness", "Focus"],
  },
]
